import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'centsToEuros'
})
export class CentsToEurosPipe implements PipeTransform {

  transform(cents: number): string {
    if (cents) {
      return `${cents / 100} €`;
    }
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/cents-to-euros.pipe.ts